import { store } from "@store";

const getCatalogueName = async () => {
  return store.getState().user?.user?.catalogue_name || "DELHI_NCR";
};

export default getCatalogueName;
